export class QRoundRect {
  constructor() {
    this.fLeft = 0;
    this.fTop = 0;
    this.fRight = 0;
    this.fBottom = 0;
    this.fCornerRadius = 0;
  }

  InitRoundRect(left, top, right, bottom, cornerRadius) {
    this.fLeft = left;
    this.fTop = top;
    this.fRight = right;
    this.fBottom = bottom;
    this.fCornerRadius = cornerRadius;
  }

  Clone() {
    var theC = new QRoundRect();
    theC.fLeft = this.fLeft;
    theC.fRight = this.fRight;
    theC.fTop = this.fTop;
    theC.fBottom = this.fBottom;
    theC.fCornerRadius = this.fCornerRadius;

    return theC;
  }

  Shift(deltaX, deltaY) {
    this.fLeft = this.fLeft + deltaX;
    this.fRight = this.fRight + deltaX;
    this.fTop = this.fTop + deltaY;
    this.fBottom = this.fBottom + deltaY;
  }

  Scale(scaleFactor) {
    this.fLeft = this.fLeft * scaleFactor;
    this.fRight = this.fRight * scaleFactor;
    this.fTop = this.fTop * scaleFactor;
    this.fBottom = this.fBottom * scaleFactor;

    this.fCornerRadius = this.fCornerRadius * scaleFactor;
  }
}
